import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Autocomplete from '@mui/material/Autocomplete';
import { useNavigate, useLocation } from 'react-router-dom';
import config from '../../../config';
import apiService from '../../../utlis/apiService';
import {
  ArrowBackIos as BackButton,
} from '@mui/icons-material';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { getMode, getStatusType } from '../../../utlis/commonFunction';

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const CreateCourseForm = () => {
  let query = useQuery();
  let id = query.get('id');
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    student: '',
    type: '',
    admission: '',
    category: '',
    categoryTo: '',
    statusType: '',
    mode: '',
    categoryObj: '',
  });
  const [page, setPage] = useState(0);
  const [students, setStudents] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [admissions, setAdmissions] = useState([]);
  const [selectedAdmission, setSelectedAdmission] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [category, setCategory] = useState([]);
  const [categoryTo, setCategoryTo] = useState([]);
  const [selectedCategoryTo, setSelectedCategoryTo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [errors, setErrors] = useState({
    name: '',
    student: '',
    type: '',
  });
  const [statusType, setStatusType] = useState([]);

  const mode = getMode();

  useEffect(() => {
    fetchStatusTypeData();
  }, []);
  
  useEffect(() => {
    const fetchTicketData = async () => {
      try {
        if (id) {
          const response = await apiService.get('/course/get', {
            params: {
              id: id,
            },
          });
          setFormData(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };
  
    fetchTicketData();
  }, [id]);

  useEffect(() => {
    fetchStudents(page, searchQuery);
  }, [page, searchQuery]);

  useEffect(() => {
    if(formData.student) {
      fetchStudentAdmissions();
    }
  }, [formData.student]);

  useEffect(() => {
    if(selectedAdmission && formData.statusType && formData.type === 'Scheme Change') {
      fetchCategories();
    }
  }, [selectedAdmission, formData.statusType, formData.type]);

  const fetchStudents = async (pageNumber, query) => {
    setLoading(true);
    try {
      const response = await apiService.get(`/student/list`, {
        params: {
          searchTerm: query,
          page: pageNumber
        },
      });
      setStudents(response?.data?.students ?? []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCategories = async () => {
    setLoading(true);
    try {
      const data = {
        courseId: selectedAdmission?.course?._id,
        statusType: formData.statusType,
        year: '',
      }

      const response = await apiService.post(`/level/list/categoryByCourse`, data);
      setCategoryTo(response?.data?.categories ?? []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchStatusTypeData = async () => {
		const statusTypeData = await getStatusType();
		setStatusType(statusTypeData);
	}

  const fetchStudentAdmissions = async () => {
    setLoading(true);
    try {
      const response = await apiService.get(`/student/get/admission`, {
        params: {
          studentId: formData.student
        },
      });
      setAdmissions(response?.data?.admission ?? []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  const handleSearchOptionChange = (event, newQuery) => {
    setSearchQuery(newQuery);
    setPage(1);
    setStudents([]);
  }

  const handleChangeStudent = async (newValue) => {
    setSelectedStudent(newValue);
    setFormData((prevData) => ({
      ...prevData,
      student: newValue?._id,
    }));
  };

  const handleChangeCourse = async (newValue) => {
    setSelectedAdmission(newValue);
    setCategory(newValue.category);
    setFormData((prevData) => ({
      ...prevData,
      admission: newValue?._id,
    }));
  };

  const handleChangeCategory = async (newValue) => {
    setSelectedCategory(newValue);
    setFormData((prevData) => ({
      ...prevData,
      categoryObj: newValue?._id,
      category: newValue?.category?._id,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleChangeCategoryTo = (newValue) => {
    setSelectedCategoryTo(newValue);
    setFormData((prevData) => ({
      ...prevData,
      categoryTo: newValue?._id,
    }));
  }

 
  const validateForm = () => {
    let isValid = true;
    const newErrors = {
      name: '',
      student: '',
      type: '',
    };

    if (!formData.name) {
      newErrors.name = 'Please enter a name.';
      alert('Please enter a name.');
      isValid = false;
    }

    if (!formData.student) {
      newErrors.student = 'Please select a student.';
      alert('Please select a student.');
      isValid = false;
    }

    if (!formData.type) {
      newErrors.type = 'Please enter a type.';
      alert('Please enter a type.');
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      let murl = `${config.apiUrl}/student-ticket/create`;
      try {
        const response = await apiService.post(murl, formData, {
          headers: {
            'Content-Type': 'application/json',
          },
        });
        navigate(-1);
        console.log(JSON.stringify(response.data));
      } catch (error) {
        alert(error?.response?.data?.error);
        console.error(error);
      }
    }
  };



  return (
    <div>
      <h1 style={{ cursor: 'pointer', width: 'fit-content' }} onClick={() => navigate(-1)}>
        <BackButton />
        Student Support
      </h1>
      <form onSubmit={handleSubmit}>
        <Typography variant="h4" gutterBottom>
          {id ? 'Edit' : 'Create'} Ticket
        </Typography>
        <Autocomplete
          id="students-autocomplete"
          value={selectedStudent}
          options={students}
          getOptionLabel={(option) => option.firstName + ' ' + option.lastName + ' / '+ option.phoneNumber}
          onChange={(event, newValue) => handleChangeStudent(newValue)}
          loading={loading}
          onInputChange={handleSearchOptionChange}
          renderInput={(params) => (
            <TextField {...params} label="Student *" />
          )}
          sx={{ marginTop: '15px' }}
          size="small"
        />
        <TextField
          label="Ticket Name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          fullWidth
          required
          margin="normal"
          size="small"
        />
        <FormControl fullWidth style={{ marginTop: '10px'}} size='small'>
          <InputLabel id="Type">Type *</InputLabel>
          <Select
            label="Type"
            name="type"
            value={formData.type}
            onChange={handleChange}
            fullWidth
            margin="normal"
            size='small'
            required
          >
            <MenuItem value="Drop">Drop</MenuItem>
            <MenuItem value="Scheme Change">Scheme Change</MenuItem>
          </Select>
        </FormControl>
        
        <Autocomplete
          id="course-autocomplete"
          value={selectedAdmission}
          options={admissions}
          getOptionLabel={(option) => option.course?.name}
          onChange={(event, newValue) => handleChangeCourse(newValue)}
          loading={loading}
          renderInput={(params) => (
            <TextField {...params} label="Course *" />
          )}
          sx={{ marginTop: '15px' }}
          size="small"
        />
        
        <Autocomplete
          id="category-autocomplete"
          value={selectedCategory}
          options={category}
          getOptionLabel={(option) => option.category?.name}
          onChange={(event, newValue) => handleChangeCategory(newValue)}
          loading={loading}
          renderInput={(params) => (
            <TextField {...params} label="Category *" />
          )}
          sx={{ marginTop: '15px' }}
          size="small"
        />

        {formData.type === 'Scheme Change' ? 
          <>
            <Typography sx={{ marginTop: "20px" }} >Scheme Change Target To: </Typography>
            <FormControl fullWidth>
              <TextField
                label="Status Type"
                select
                value={formData.statusType}
                onChange={handleChange}
                fullWidth
                name="statusType"
                margin="normal"
                error={Boolean(errors.statusType)}
                helperText={errors.statusType}
                required
                size='small'
              >
                  {statusType?.map((type, index) => (
                    <MenuItem key={index} value={type}>{type}</MenuItem>
                  ))}
              </TextField>
            </FormControl>

            <FormControl fullWidth>
              <TextField
                label="Mode"
                select
                value={formData.mode}
                onChange={handleChange}
                fullWidth
                name="mode"
                margin="normal"
                required
                size='small'
                error={Boolean(errors.mode)}
                helperText={errors.mode}
              >
                {mode.map((mode, index) => (
                  <MenuItem value={mode} key={index}>{mode}</MenuItem>
                ))}
              </TextField>
            </FormControl>

            <Autocomplete
              id="categoryTo-autocomplete"
              value={selectedCategoryTo}
              options={categoryTo}
              getOptionLabel={(option) => option?.name}
              onChange={(event, newValue) => handleChangeCategoryTo(newValue)}
              loading={loading}
              renderInput={(params) => (
                <TextField {...params} label="Category To *" />
              )}
              sx={{ marginTop: '15px' }}
              size="small"
            />
          </>
        : ''}
    
        <Button type="submit" variant="contained" color="primary" style={{ marginTop: '20px' }}>
          {id ? 'Update Ticket' : 'Create Ticket'}
        </Button>
      </form>
    </div>
  );
};

export default CreateCourseForm;
